import { render, staticRenderFns } from "./CopyClipboardMenu.vue?vue&type=template&id=6db94518&scoped=true&"
import script from "./CopyClipboardMenu.vue?vue&type=script&lang=js&"
export * from "./CopyClipboardMenu.vue?vue&type=script&lang=js&"
import style0 from "./CopyClipboardMenu.vue?vue&type=style&index=0&id=6db94518&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db94518",
  null
  
)

export default component.exports